import { render, staticRenderFns } from "./BuyFilter.vue?vue&type=template&id=461e1d10&scoped=true&"
import script from "./BuyFilter.vue?vue&type=script&lang=js&"
export * from "./BuyFilter.vue?vue&type=script&lang=js&"
import style0 from "./BuyFilter.vue?vue&type=style&index=0&id=461e1d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e1d10",
  null
  
)

export default component.exports